import { Component, OnInit } from '@angular/core';
import { $DBManagerService } from './_helpers/DB/DBManager.service';
import { Constants } from './_utils/Constants';
import { Router } from '@angular/router';
import { $BroadcastManagerService } from './_helpers/BroadcastManager.service';
import { NgxSpinnerService } from 'ngx-spinner';

import { BnNgIdleService } from 'bn-ng-idle';

@Component({
  selector: 'app-root',
  template: `
  <app-loader></app-loader>
  <router-outlet></router-outlet>
  `,
  styleUrls: ['./app.component.css']
})
export class AppComponent {


  constructor(
    private evt: $BroadcastManagerService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private bnIdle: BnNgIdleService
    
  ) {
    this.router.events.subscribe((val) => {
      this.evt.emit({ click: 'HIDE' });
    });
   
    this.bnIdle.startWatching(600).subscribe((res) => {
      if(res) {
          console.log("session expired");
          localStorage.removeItem('currentUser');
		  this.router.navigate(['/']);
      }
    })
  }
  ngOnInit() {
  
  }

}
